import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { createUserTransactions } from 'src/axious/user-transactions'
import { Header } from 'src/components'
import { CustomButton, DynamicInput, Loading, TransactionContainer } from 'src/components/ui'
import { handleAxiosError } from 'src/utils/errorHandling'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import styles from './WithdrawalTonWallet.module.scss'

interface Props {
  className?: string
}

const WithdrawalTonWalletPage: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const userId = useGlobalStore((state) => state.user?.id) || 0
  const reducingBalanceStars = useGlobalStore((store) => store.reducingBalanceStars)

  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const starsAmount = searchParams.get('stars') || 0

  const [inputValue, setInputValue] = useState<string>('')

  const [isLoading, setIsLoading] = useState(false)

  const handleChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const withdrawalStars = async (walletAddress: string) => {
    setIsLoading(true)
    try {
      await createUserTransactions({
        amount_stars: +starsAmount,
        commission: 0,
        type: 'WITHDRAWAL',
        wallet: walletAddress,
        withdrawalType: 'USDT',

        recipient: +userId,
        gift_id: '',
      })

      reducingBalanceStars(+starsAmount)
      navigate('/withdrawal/success?type=withdrawal&withdrawal_type=in_ton')
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      navigate('/withdrawal/error')

      const errorMessage = handleAxiosError(error)
      console.log('errorMessage', errorMessage)
    }
  }

  return (
    <div className={className}>
      <Header variant='back' action='add' path='..' />

      {isLoading && <Loading />}

      <main className={styles.wrapper}>
        <h1>{t('withdrawal_page.ton.title')}</h1>
        <p className={styles.wrapper_subtitle}>{t('withdrawal_page.ton.wallet.address')}</p>

        <DynamicInput
          inputValue={inputValue}
          onChange={handleChangeInputValue}
          showIcon={false}
          placeholder='x'
          type='text'
          inputMode='text'
          className={styles.input}
        />
      </main>

      <CustomButton
        onClick={() => withdrawalStars(inputValue)}
        variant={inputValue.length === 0 ? 'not-active' : 'contained'}
        color='white'
        className={styles.button}
      >
        {t('withdrawal_page.ton.button_text')}
      </CustomButton>
    </div>
  )
}

export default WithdrawalTonWalletPage
